import { ApiCore } from "./utilities/core";

const url = 'process_mining/attribute_search';

const apiCaseAttributesColumnsData = new ApiCore({
    getAll: false,
    getSingle: false,
    post: false,
    postSingle: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
});

export default apiCaseAttributesColumnsData;